import { type Maybe } from 'dibs-ts-utils/exports/Maybe.ts';

// Manifold uses a convention of adding `#x/n` to ERC721 token's name
// field in the metadata that are meant to be an edition of a number
// of NFTS. This function extracts the edition number from the token
// or takes the edition from the metadata edition field.
export function getEditionFromNftName(name: Maybe<string>, edition: Maybe<string>): string | null {
    if (!name) {
        return null;
    }

    // extract edition from name if it exists
    const editionRegex = /\#(\d+\/\d+)/gm;
    const matches = editionRegex.exec(name);
    let editionStr = '';
    if (matches && matches.length > 1) {
        matches.forEach(match => {
            // take the last match
            editionStr = match;
        });
        return editionStr;
    } else if (edition && edition !== '') {
        // otherwise use edition (probably from metadata)
        return edition;
    }
    return null;
}
